import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

// Keeps the language preference in the URL (?lang=hi) in sync with app state,
// in both directions, and re-applies it across route navigation so it persists.
export const LanguageUrlSync = () => {
  const { lang, setLang } = useLang();
  const location = useLocation();
  const navigate = useNavigate();

  // URL -> state (handles first load, shared links, back/forward)
  useEffect(() => {
    const param = new URLSearchParams(location.search).get("lang");
    const normalized = param === "hi" || param === "hinglish" || param === "en" ? param : null;
    if (normalized && normalized !== lang) setLang(normalized);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  // state -> URL (toggle) + re-apply after navigation (Links drop query params)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const current = params.get("lang");

    if (lang === "hi" || lang === "hinglish") {
      if (current === lang) return;
      params.set("lang", lang);
    } else {
      if (!current) return; // keep English URLs clean
      params.delete("lang");
    }

    const search = params.toString();
    navigate(
      { pathname: location.pathname, search: search ? `?${search}` : "", hash: location.hash },
      { replace: true }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, location.pathname, location.search]);

  return null;
};
